// Catalogue de formats de déclinaisons publicitaires & impression
export const FORMAT_CATALOG = [
  {
    category: "ADOPS_WEB",
    label: "ADOPS WEB",
    items: [
      { name: "1600x1000", width: 1600, height: 1000 },
      { name: "300x250", width: 300, height: 250 },
    ],
  },
  {
    category: "ADOPS_APP",
    label: "ADOPS APP",
    items: [
      { name: "1280x500", width: 1280, height: 500 },
      { name: "640x250", width: 640, height: 250 },
      { name: "640x1136", width: 640, height: 1136 },
      { name: "720x1280", width: 720, height: 1280 },
    ],
  },
  {
    category: "NEWSLETTERS",
    label: "NEWSLETTERS",
    items: [{ name: "1280x400", width: 1280, height: 400 }],
  },
  {
    category: "PAID",
    label: "PAID",
    items: [
      { name: "1080x1920", width: 1080, height: 1920 },
      { name: "1200x1200", width: 1200, height: 1200 },
      { name: "1200x628", width: 1200, height: 628 },
    ],
  },
  {
    category: "INAPP",
    label: "INAPP",
    items: [{ name: "1000x571", width: 1000, height: 571 }],
  },
  {
    category: "PROGRAMMATIQUE",
    label: "PROGRAMMATIQUE",
    items: [
      { name: "300x250", width: 300, height: 250 },
      { name: "300x600", width: 300, height: 600 },
      { name: "600x450", width: 600, height: 450 },
      { name: "970x250", width: 970, height: 250 },
      { name: "2560x1440", width: 2560, height: 1440 },
    ],
  },
  {
    category: "PRINT",
    label: "PRINT",
    items: [
      { name: "A5 Portrait", width: 1748, height: 2480 },
      { name: "A5 Paysage", width: 2480, height: 1748 },
      { name: "A4 Portrait", width: 2480, height: 3508 },
      { name: "A4 Paysage", width: 3508, height: 2480 },
      { name: "A3 Portrait", width: 3508, height: 4961 },
      { name: "A3 Paysage", width: 4961, height: 3508 },
    ],
  },
  {
    category: "EXPORT_HD",
    label: "EXPORT HD",
    items: [
      { name: "Full HD", width: 1920, height: 1080 },
      { name: "Full HD Vertical", width: 1080, height: 1920 },
      { name: "2K QHD", width: 2560, height: 1440 },
      { name: "4K UHD", width: 3840, height: 2160 },
      { name: "4K Vertical", width: 2160, height: 3840 },
      { name: "4K Square", width: 2160, height: 2160 },
    ],
  },
];

export const formatKey = (category, item) =>
  `${category}__${item.name}__${item.width}x${item.height}`;
